var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEllipse = function SvgEllipse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 4,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#868686"
  })));
};
export default SvgEllipse;